import api from "./api";

export const CalendarAPI = {
  listEvents() {
    return api("/calendar/events");
  },
};